/**
 * 사이드바 「다가올 일정」의 구간 — **보고 있는 화면과 무관하게** «오늘 00:00 ~ 다음 주 끝» (2026-10-13).
 *
 * ⛔ 종전에는 화면이 이미 받은 일정(`visibleEvents`)을 다시 썼다 ⇒ 지난 달·먼 달을 보고 있으면
 *   다가올 일정이 «비거나», 보고 있는 달 끝에서 잘렸다. 다가올 일정은 «지금»의 말이라 화면과 갈라야 한다.
 *
 * ⚠ 주의 시작은 **일요일**이다 — 월간 격자·주간 구간이 모두 `getDay()`(일=0)로 일요일을 구한다
 *   (`CalendarPage.tsx` 의 range · `TimeGridView.WeekView`). ⇒ 「다음 주 끝」은 다음 주 **토요일 23:59:59.999**,
 *   곧 `to` 는 **이번 주 일요일 + 14일 00:00(배타)** 이다.
 */
export interface UpcomingWindow {
  from: Date;
  /** 배타 — 이 순간은 «안» 들어간다. */
  to: Date;
}

export function upcomingWindow(now: Date): UpcomingWindow {
  const from = new Date(now);
  from.setHours(0, 0, 0, 0);
  const to = new Date(from);
  to.setDate(from.getDate() - from.getDay() + 14);
  return { from, to };
}

/** 이미 받아 둔 구간(ISO)이 다가올 일정 구간을 «통째로» 덮나 — 덮으면 따로 받지 않는다. */
export function rangeCoversWindow(loaded: { from: string; to: string } | null, win: UpcomingWindow): boolean {
  if (!loaded) return false;
  const lf = Date.parse(loaded.from);
  const lt = Date.parse(loaded.to);
  if (!Number.isFinite(lf) || !Number.isFinite(lt)) return false;
  return lf <= win.from.getTime() && lt >= win.to.getTime();
}

/** 그 구간에 «걸친» 일정인가(시작 < to && 끝 >= from). */
export function overlapsWindow(startAt: string, endAt: string, win: UpcomingWindow): boolean {
  return new Date(startAt).getTime() < win.to.getTime() && new Date(endAt).getTime() >= win.from.getTime();
}
